export default function SpyGlass() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.3636 29.4999L22.9136 23.0499M26.3633 14.5C26.3633 21.1274 20.9907 26.5 14.3633 26.5C7.73586 26.5 2.36328 21.1274 2.36328 14.5C2.36328 7.87258 7.73586 2.5 14.3633 2.5C20.9907 2.5 26.3633 7.87258 26.3633 14.5Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}